<template>
    <el-card>
        <div slot="header" class="clearfix">
            <span>统计分析</span>
            <el-select v-if="isAdmin" v-model="ukey" clearable filterable size="small" @change="onSearch">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in staffOption" :key="item.key" :label="item.name" :value="item.key"></el-option>
            </el-select>
            <el-select v-model="formId" clearable filterable size="small" placeholder="来源" @change="onSearch">
                <el-option v-for="item in formOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div class="mainBox">
            <div style="display: flex;gap: 20px;justify-content: space-between;">
                <div style="width: 50%;display: flex;gap: 10px;flex-wrap: wrap;">
                    <el-card style="width: calc(50% - 7px);" v-loading="loadingOne">
                        <div slot="header" class="title">
                            <span>询盘</span>
                            <span class="time sp1">今日</span>
                        </div>
                        <div class="oneItem">
                            <span class="count">{{ topInfo.toDayCount }}</span>
                            <span class="unit">/个</span>
                        </div>
                    </el-card>
                    <el-card style="width: calc(50% - 7px);" v-loading="loadingOne">
                        <div slot="header" class="title">
                            <span>询盘</span>
                            <span class="time sp2">本周</span>
                        </div>
                        <div class="oneItem">
                            <span class="count">{{ topInfo.weekCount }}</span>
                            <span class="unit">/个</span>
                        </div>
                    </el-card>
                    <el-card style="width: calc(50% - 7px);" v-loading="loadingOne">
                        <div slot="header" class="title">
                            <span>询盘</span>
                            <span class="time sp3">本月</span>
                        </div>
                        <div class="oneItem">
                            <span class="count">{{ topInfo.monthCount }}</span>
                            <span class="unit">/个</span>
                        </div>
                    </el-card>
                    <el-card style="width: calc(50% - 7px);" v-loading="loadingOne">
                        <div slot="header" class="title">
                            <span>跟进</span>
                            <span class="time sp1">今日</span>
                        </div>
                        <div class="oneItem">
                            <span class="count">{{ topInfo.followCount }}</span>
                            <span class="unit">/次</span>
                        </div>
                    </el-card>
                </div>
                <el-card style="width: 50%;" v-loading="loadingTwo">
                    <div slot="header" class="title">趋势分析</div>
                    <div ref="trend-analyze-dom" style="width: 100%;height: 255px;"></div>
                </el-card>
            </div>
            <div style="display: flex;gap: 20px;justify-content: space-between;margin-top: 20px;">
                <el-card style="width: 50%;" v-loading="loadingThree">
                    <div slot="header" class="title">国家分析</div>
                    <el-table :data="countryData" style="width: 100%;" height="255">
                        <el-table-column prop="country" label="国家"></el-table-column>
                        <el-table-column prop="toDayNum" label="今日新增询盘"></el-table-column>
                        <el-table-column prop="num" label="询盘总数"></el-table-column>
                    </el-table>
                </el-card>
                <el-card style="width: 50%;" v-loading="loadingFour">
                    <div slot="header" class="title">阶段分析</div>
                    <el-table :data="phaseData" style="width: 100%;" height="255">
                        <el-table-column prop="phase" label="阶段"></el-table-column>
                        <el-table-column prop="num" label="询盘总数"></el-table-column>
                    </el-table>
                </el-card>
            </div>
            <el-card style="margin-top: 20px;" v-loading="loadingFive">
                <div slot="header" class="title">员工分析</div>
                <el-table :data="staffData" style="width: 100%;" height="500">
                    <el-table-column prop="userName" label="员工"></el-table-column>
                    <el-table-column prop="totalNum" label="询盘总数"></el-table-column>
                    <el-table-column prop="toDayFollowNum" label="今日跟进次数"></el-table-column>
                    <el-table-column prop="followNum" label="跟进总次数"></el-table-column>
                    <el-table-column prop="toDayConvertCustomerNum" label="今日转换客户数量"></el-table-column>
                    <el-table-column prop="convertCustomerNum" label="转换客户总数量"></el-table-column>
                    <el-table-column prop="lastFollowTime" label="最近跟进时间" width="160"></el-table-column>
                    <el-table-column prop="lastFollowContent" label="最近跟进内容" width="280" show-overflow-tooltip></el-table-column>
                </el-table>
            </el-card>
        </div>
    </el-card>
</template>

<script>
import * as echarts from "echarts";
export default {
    chartInstance: {
        trendAnalyze: null,
    },
    data() {
        return {
            isAdmin: false,
            //筛选条件
            formId: "",
            ukey: "",
            //统计信息
            topInfo: {},
            countryData: [],
            phaseData: [],
            staffData: [],
            //下拉框数据
            staffOption: [],
            formOption: [],
            //加载状态
            loadingOne: false,
            loadingTwo: false,
            loadingThree: false,
            loadingFour: false,
            loadingFive: false,
        };
    },
    methods: {
        //头部统计信息
        getReportTop(){
            this.loadingOne = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Report/Top`,{
                "formId": this.formId,
                "ukey": this.ukey,
            }).then((res) => {
                this.loadingOne = false;
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.topInfo = data;
                }
            });
        },
        //趋势分析统计
        getTrend(){
            this.loadingTwo = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Report/Trend`,{
                "formId": this.formId,
                "ukey": this.ukey,
            }).then((res) => {
                this.loadingTwo = false;
                const { isSuccess, data } = res;
                if (isSuccess) {
                    const { xData , yData } = data;
                    this.$options.chartInstance.trendAnalyze.setOption({
                        xAxis: {
                            data: xData,
                        },
                        series: {
                            data: yData,
                        } 
                    });
                    this.$options.chartInstance.trendAnalyze.resize();
                }
            });
        },
        //国家分析统计
        getCountryAnalysis(){
            this.loadingThree = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Report/CountryAnalysis`,{
                "formId": this.formId,
                "ukey": this.ukey,
            }).then((res) => {
                this.loadingThree = false;
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.countryData = data;
                }
            });
        },
        //阶段分析统计
        getPhaseAnalysis(){
            this.loadingFour = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Report/PhaseAnalysis`,{
                "formId": this.formId,
                "ukey": this.ukey,
            }).then((res) => {
                this.loadingFour = false;
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.phaseData = data;
                }
            });
        },
        //员工分析统计
        getStaffAnalysis(){
            this.loadingFive = true;
            this.$axios.post(`${this.$customerUrl}/AdvertisingForm/Report/StaffAnalysis`,{
                "formId": this.formId,
                "ukey": this.ukey,
            }).then((res) => {
                this.loadingFive = false;
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.staffData = data;
                }
            });
        },
        onSearch(){
            this.getReportTop();
            this.getTrend();
            this.getCountryAnalysis();
            this.getPhaseAnalysis();
            this.getStaffAnalysis();
        }

    },
    mounted() {
        this.isAdmin = localStorage.userInfo ? JSON.parse(localStorage.userInfo).isAdmin : false;
        //如果不是管理员，则默认查询当前用户的数据
        if(!this.isAdmin){
            this.ukey = localStorage.userInfo ? JSON.parse(localStorage.userInfo).uKey : "";
        }else{
            //获取所有成员集合
            this.$axios.get(`${this.$personnelUrl}/Organization/FindStaffBox`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.staffOption = data;
                }
            })
        }
        //获取表单下拉框
        this.$axios.get(`${this.$customerUrl}/AdvertisingForm/FormBox`).then((res) => {
            const { isSuccess, data } = res;
            if (isSuccess) {
                this.formOption = data;
            }
        });

        this.$options.chartInstance.trendAnalyze = echarts.init(
            this.$refs["trend-analyze-dom"]
        );
        this.$options.chartInstance.trendAnalyze.setOption({
            grid: {
                containLabel: true,
                top: 20,
                left: 20,
                right: 20,
                bottom: 20,
            },
            xAxis: {
                axisLine: {
                    lineStyle: {
                        color: "#BFBFBF",
                    },
                },
                axisTick: {
                    alignWithLabel: true,
                },
                axisLabel: {
                    color: "#595959",
                },
                data: [],
            },
            yAxis: {
                axisLabel: {
                    color: "#595959",
                },
                splitLine: {
                    lineStyle: {
                        color: "#E7E7E7",
                        type: "dashed",
                    },
                },
            },
            tooltip: {
                trigger: "axis",
            },
            series: [
                {
                    data: [],
                    type: 'line',
                    smooth: true
                }
            ]
        });
        
        //初始化数据
        this.onSearch();
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__header{
    padding: 10px 20px;
}
::v-deep .el-card__body{
    padding: 0;
}
.clearfix{
    display: flex;
    gap: 20px;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
}

.mainBox{
    height: calc(100vh - 210px);
    padding: 12px;
    overflow: auto;
}

.title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #3a3a3a;
    font-weight: bold;
    .time{
        display: inline-block;
        height: 20px;
        line-height: 20px;
        border-radius: 4px;
        padding: 0 4px;
        font-size: 12px;
        color: #fff;
    }
    .sp1{
        background-color: #67C23A;
    }
    .sp2{
        background-color: #409EFF;
    }
    .sp3{
        background-color: #F56C6C;
    }
}
.oneItem{
    text-align: center;
    padding: 10px;
    line-height: 75px;
    .count{
        font-size: 28px;
        color: #3a3a3a;
        font-weight: bold;
    }
    .unit{
        font-size: 14px;
        color: #6a6a6a;
    }
}

</style>